/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Optional list of task IDs to focus on
 */
export type AssessmentRequestFocusTasks = string[] | null;
